import { useEffect, useState } from "react";
import { siteNav } from "@/mocks/editorial";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
      const secs = ["radar", "columns", "deep", "faq", "about"];
      let current = "";
      for (const id of secs) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) current = id;
      }
      setActive(current);
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-ink-950/95 backdrop-blur-md shadow-soft py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-center justify-between">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-3 cursor-pointer"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-ember-600 text-paper-50">
              <i className="ri-quill-pen-fill text-lg" />
            </span>
            <span className="font-display text-left leading-none">
              <span className="block text-xl font-black tracking-wide text-paper-50">大瓜观察局</span>
              <span className="mt-1 block text-[10px] tracking-[0.2em] text-paper-200/70">BEHIND THE CAMERA</span>
            </span>
          </button>

          <nav className="hidden items-center gap-1 lg:flex">
            {siteNav.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === n.id
                    ? "bg-ember-600 text-paper-50"
                    : "text-paper-100/80 hover:bg-paper-50/10 hover:text-paper-50"
                }`}
              >
                {n.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#feedback"
              className="hidden whitespace-nowrap rounded-full border border-paper-50/25 px-5 py-2 text-sm text-paper-50 transition hover:border-ember-500 hover:bg-ember-600 md:inline-flex"
            >
              <i className="ri-notification-2-line mr-2" />
              线索投稿
            </a>
            <button
              onClick={() => setOpen(!open)}
              aria-label="打开菜单"
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg text-paper-50 hover:bg-paper-50/10 lg:hidden"
            >
              <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="border-t border-paper-50/10 bg-ink-950/98 px-4 pb-6 pt-3 lg:hidden">
          <nav className="flex flex-col gap-1">
            {siteNav.map((n) => (
              <button
                key={n.id}
                onClick={() => go(n.id)}
                className="cursor-pointer rounded-lg px-3 py-3 text-left text-sm text-paper-100/85 hover:bg-paper-50/10"
              >
                {n.label}
              </button>
            ))}
            <a
              href="#feedback"
              className="mt-2 inline-flex items-center justify-center rounded-full bg-ember-600 px-5 py-3 text-sm text-paper-50"
            >
              <i className="ri-notification-2-line mr-2" />
              线索投稿
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}